import { FetchArgs } from 'src/app/shared/models/core';
import { MappingEntityType } from '../../enums/mapping-entity-type.enum';
import { IntegrationLookup } from '../../models/integration-lookup.model';

export type SelectOptions = Array<{ value: string | MappingEntityType; text: string }>;

export const integrationMappingsRoute = '/admin/integration-mapping';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const defaultFetchArgs = {
    filter: {},
    sort: {},
    skip: 0,
    pageSize: 50
} as FetchArgs;

export const loadEntityTypeOptions = (): SelectOptions => {
    const options = Object.entries(MappingEntityType)
        .filter((x) => isNaN(Number(x[0])))
        .map((v) => {
            return {
                value: v[1],
                text: v[0]
            };
        });
    return options;
};

export const convertToSelectOption = (x: IntegrationLookup): Array<{ value: string; text: string }> =>
    ([...Object.keys(x.clientIntegrationType)] || []).map((client) => {
        return {
            value: client,
            text: client.toUpperCase()
        };
    });

export const IntegrationMappingsUtility = {
    defaultFetchArgs,
    integrationMappingsRoute,
    loadEntityTypeOptions,
    convertToSelectOption
};
